(function() {

  "use strict";
  var COLORS = ['#f64f5f',
    ' #4a2c4d',
    '#37aa32',
    '#f69143',
    '#b3274a',
    '#2c4883',
    '#009688',
    '#592716'
  ];
  define('fg-arv/widget',['fg-arv/constants', 'fg-arv/utils', 'fg-arv/templates', 'fg-arv/components/locationInput',
      'fg-arv/components/datepicker',
      'fg-arv/components/time', 'fg-arv/components/combobox', 'fg-arv/google-helper', 'fg-arv/components/mapView',
      'fg-arv/components/journeys',
      'fg-arv/fromToMarkers', 'fg-arv/components/autocomplete', 'fg-arv/components/unitSystem',
      'fg-arv/components/help', 'fg-arv/components/legend', 'fg-arv/components/zoomControl'
    ],
    function(constants, utils, tmpl, locationInput, datepicker, time, combobox, googleHelper, mapView, journeys,
      fromToMarkers, autocomplete, unitSystem, help, legend, zoomControl) {

      var mapInstance;

      var MapWidget = function(apiObject) {
        this.apiObject = apiObject;
        var rootElementID = apiObject.getDOMElementID();
        var rootElementSelector = "#" + rootElementID;
        var mapElementID = rootElementID + "-map";
        var mapElementSelector = "#" + mapElementID;
        var widget = this;
        widget.colors = COLORS;
        var rootElement = jQuery(rootElementSelector);
        if (!rootElement || rootElement.length !== 1) {
          return undefined; // Abort!
        }
        this.widgetElement = jQuery(rootElementSelector)
          .html(tmpl.createWidgetTemplate(mapElementID)); // Insert HTML structure

        // ------- Options for Google Map -----------
        var mapOptions = {
          center: new google.maps.LatLng(51.5008, 0.1247),
          zoom: 11,
          minZoom: 5,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          zoomControl: false,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          scaleControl: false,
          panControl: false,
          streetViewControl: false,
          overviewMapControl: false
        };

        this.map = new google.maps.Map(jQuery(mapElementSelector)[0], mapOptions);
        mapInstance = this.map;

        widget.unitSystemComponent = unitSystem.createComponent({
          widget: widget
        });
        widget.legend = legend.createComponent({
          widget: widget
        });
        //Create zoom control
        widget.zoomControl = zoomControl.createComponent({
          widget: widget
        });
        rootElement.find(".form").addClass('complete');

        widget.formControl = rootElement.find(".form")[0];
        jQuery(widget.map.getDiv()).append(widget.formControl);
        //jQuery(widget.formControl).addClass('map-control');
        //widget.map.controls[google.maps.ControlPosition.LEFT_TOP].push(widget.formControl);

        google.maps.event.addListenerOnce(this.map, 'idle', function() {
          rootElement.find('.map-control').show();
          if (window.innerWidth <= 540) {
            jQuery(widget.formControl).find('.form-components-container').closest('.form').addClass(
              'mobile-mode');
          }
        });


        this.unitSystem = widget.unitSystemComponent.getValue();
        this.fromComponent = locationInput.createComponent({
          container: rootElement.find(".from-component"),
          placeholder: 'Enter station/position',
          classFromTo: 'from',
          title: 'Departure location.',
          focusCallback: function() {
            if (widget.focusedLocation == widget.toComponent) {
              widget.toComponent.blur();
            }

            widget.focusedLocation = widget.fromComponent;
          },
          changeCallback: function(movePosition) {

            widget.triggerEvent(constants.events.locationChanged, {
              changedLocation: widget.fromComponent,
              movePosition: movePosition
            });
          }

        });

        autocomplete.addAutocomplete(this.fromComponent, this);
        rootElement.find(".fg-arv_transfer")
          .click(function() {
            widget.triggerEvent(constants.events.fromToExchange, widget.fromComponent);
          });

        this.toComponent = locationInput.createComponent({
          container: rootElement.find(".to-component"),
          placeholder: 'Enter station/position',
          classFromTo: 'to',
          title: 'Arrival location.',
          focusCallback: function() {
            if (widget.focusedLocation == widget.fromComponent) {
              widget.fromComponent.blur();
              setTimeout(function() {
                widget.toComponent.getElement().focus();
              }, 100);
            }

            widget.focusedLocation = widget.toComponent;


          },
          changeCallback: function(movePosition) {

            widget.triggerEvent(constants.events.locationChanged, {
              changedLocation: widget.toComponent,
              movePosition: movePosition
            });
          }
        });
        autocomplete.addAutocomplete(this.toComponent, this);
        this.fromComponent.focus();


        this.dateComponent = datepicker.createComponent({
          container: rootElement.find(".fg-arv_date-component"),
          changeCallback: function(newDate) {
            widget.triggerEvent(constants.events.dateChanged, newDate);
          },
          widget: widget
        });

        this.journeyModeComponent = combobox.createComponent({
          container: rootElement.find(".journey-mode-component div"),
          type: "codedValues",
          options: [{
            text: "Arrive before"
          }, {
            text: "Depart after"
          }]
        });


        this.criteriaComponent = combobox.createComponent({
          container: rootElement.find(".fg-arv_criteria-component div"),
          type: "codedValues",
          options: [{
            text: "Best route",
            travelCriteria: ''
          }, {
            text: "Fewest transfers",
            travelCriteria: 'FEWER_TRANSFERS'
          }, {
            text: "Least walking",
            travelCriteria: 'LESS_WALKING'
          }]
        });

        this.helpComponent = help.createComponent({
          container: rootElement.find('.help-component div'),
          map: widget.map,
          widget: widget
        });

        function createMobileInitPanel() {
          widget.journeysComponent = journeys.createComponent({
            container: rootElement.find(
              '.fg-arv_info-journey-component'
            )[0],
            widget: widget,
            colors: COLORS,
            initMobile: true
          });
        }
        //Hide form if from and to are in url
        if (window.innerWidth < 540 && utils.getUrlParam('from') && utils.getUrlParam('to')) {
          createMobileInitPanel();
          jQuery(widget.formControl).hide();
          jQuery(widget.formControl).addClass('hasResults');
        }

        var resizeTimeout;
        jQuery(window).resize(function() {
          if (resizeTimeout) {
            clearTimeout(resizeTimeout);
          }

          resizeTimeout = setTimeout(function() {
            if (window.innerWidth <= 540 && utils.getUrlParam('from') && utils.getUrlParam('to')) {
              if (!widget.journeysComponent) {
                createMobileInitPanel();
              }
              widget.journeysComponent.getElement().find('.panel-heading').show();

            } else {
              jQuery(widget.formControl).show();
            }
          }, 10);
        });

        var eventBus = utils.createEventBus();

        // ------- The widget model object -----------
        jQuery.extend(this, {
          elementID: rootElementID,
          elementSelector: rootElementSelector,
          apiObject: apiObject,
          /**
           * Adds a listener for an events
           * @param eventName {string}  The event's name. Take it from constants module's events enumerate.
           * @param callback {function} The listener to be removed.
           */
          addEventHandler: eventBus.addHandler,
          /**
           * Removes a listener for an events
           * @param eventName {string}  The event's name. Take it from constants module's events enumerate.
           * @param callback {function} The listener to be removed.
           */
          removeEventHandler: eventBus.removeHandler,
          /**
           * Triggers a listener for an events
           * @param eventName {string}  The event's name. Take it from constants module's events enumerate.
           * @param callback {any} They payload for the event.
           */
          triggerEvent: eventBus.trigger
        });
        this.timeComponent = time.createComponent({
          getWidget: function() {
            return widget;
          },
          container: rootElement.find(".fg-arv_time-component"),
          date: this.dateComponent.getDate()
        });
        this.getNewJourney = function(opt) {
          if (opt && opt.unitSystem) {
            widget.unitSystem = opt.unitSystem;
          }
          module.getNewJourney(widget);
        };
        this.getJourney = function(from, to, opt, callback) {
          if (widget.fromComponent.valid === false) {
            widget.fromComponent.validateValue(true);
            if (widget.journeysComponent) {
              jQuery(widget.journeysComponent).find('.panel-heading').show();
            }
          } else if (widget.toComponent.valid === false) {
            widget.toComponent.validateValue(true);
            if (widget.journeysComponent) {
              jQuery(widget.journeysComponent).find('.panel-heading').show();
            }
          } else {
            var origin = {
                address: from,
                coordinates: widget.fromComponent.getLatLon()
              },
              destination = {
                address: to,
                coordinates: widget.toComponent.getLatLon()
              };
            googleHelper.getJourney(origin, destination, opt).done(function(response) {
                var legend = rootElement.find('.fg-arv_legend-component')[0];
                if (legend) {
                  legend.hidden = false;

                }
                widget.mapViewComponent = mapView.createComponent({
                  widget: widget,
                  routes: response,
                  colors: COLORS

                });
                var container = rootElement.find(
                  '.fg-arv_info-journey-component'
                )[0];
                widget.journeysComponent = journeys.createComponent({
                  container: container,
                  routes: response,
                  widget: widget,
                  departureTime: opt.departureTime ?
                    opt.departureTime : false,
                  arrivalTime: opt.arrivalTime ?
                    opt.arrivalTime : false,
                  departureDirection: opt
                    .departureDirection,
                  arrivalDirection: opt.arrivalDirection,
                  mapViewComponent: widget.mapViewComponent,
                  colors: COLORS,
                  message: 'Ooops! We are having problems with the route for improvement works. We estimate will be resolved in four days'
                });
                if (window.innerWidth <= 540) {
                  jQuery(container).css('z-index', 2);
                }
                jQuery(widget.formControl).addClass('hasResults');
                if (callback) {
                  callback();
                }
              })
              .fail(function() {
                if (widget && widget.mapViewComponent) {
                  widget.mapViewComponent.clearRoutes();
                }
                var container = rootElement.find(
                  '.fg-arv_info-journey-component'
                )[0];

                container.innerHTML = tmpl.createNoRoutesDiv();
                var heightForm = widget.widgetElement.find('.form').height();
                if (!widget.journeysComponent) {
                  var controls = widget.map.controls[google.maps.ControlPosition['LEFT_TOP']].getArray();
                  if (jQuery.inArray(container, controls) !== -1) {
                    container = controls[jQuery.inArray(container, controls)];
                  } else {
                    var panelControl = container;
                    jQuery(widget.map.getDiv()).append(panelControl);
                  }
                  jQuery(container).css('top', heightForm + 'px');
                  jQuery(container).css('z-index', 0);

                }
                if (window.innerWidth <= 540) {
                  jQuery(container).css('top', heightForm + 'px');
                  jQuery(container).css('z-index', 0);

                }
                jQuery(widget.formControl).removeClass('hasResults');
                var legend = rootElement.find('.fg-arv_legend-component')[0];
                if (legend) {
                  legend.hidden = true;
                }
              });
          }

        };

        widget.reinitialise(apiObject);
        this.fromToMarkers = fromToMarkers.createComponent(widget);

        widget.addEventHandler(constants.events.fromToExchange, function() {
          widget._onExchange();
        });

        widget.addEventHandler(constants.events.locationSelected, function(location) {
          if (widget.focusedLocation) {
            location.name = location.name;
            widget.focusedLocation.setValue(location, true);
            widget.focusedLocation.setLatLon(location.coordinates);
            if (widget.focusedLocation == widget.fromComponent) {
              widget.toComponent.focus();
            }
          }
        });

        module.getNewJourney(widget);

        var clickTimeout;
        var goComponent = rootElement.find(".fg-arv_go-component");
        if (goComponent) {
          goComponent.click(function() {
            if (clickTimeout) {
              clearTimeout(clickTimeout);
            }
            clickTimeout = setTimeout(function() {

              if (widget.widgetElement.find('.form-components-container').closest('.form').hasClass(
                  'mobile-mode')) {
                widget.widgetElement.find('.form-components-container').removeClass('visible');
              }
              module.getNewJourney(widget, function() {
                widget.fromToMarkers.hideMarker(widget.fromComponent);
                widget.fromToMarkers.hideMarker(widget.toComponent);
              });

            }, 500);
          });
        }

        // Bounds for UK
        var strictBounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(50.024504, -10.817431),
          new google.maps.LatLng(60.976688, 2.195328)
        );

        // Listen for the dragend event
        google.maps.event.addListener(mapInstance, 'bounds_changed', function() {
          if (strictBounds.contains(mapInstance.getCenter())) return;

          // We're out of bounds - Move the map back within the bounds
          var c = mapInstance.getCenter(),
            x = c.lng(),
            y = c.lat(),
            maxX = strictBounds.getNorthEast().lng(),
            maxY = strictBounds.getNorthEast().lat(),
            minX = strictBounds.getSouthWest().lng(),
            minY = strictBounds.getSouthWest().lat();

          if (x < minX) x = minX;
          if (x > maxX) x = maxX;
          if (y < minY) y = minY;
          if (y > maxY) y = maxY;

          mapInstance.setCenter(new google.maps.LatLng(y, x));
        });
      };


      jQuery.extend(MapWidget.prototype, {
        getFocusedLocation: function() {
          return this.focusedLocation;
        },
        getMap: function() {
          return this.map;
        },
        reinitialise: function(apiObject) {
          var rootElement = jQuery(this.elementSelector);
          if (rootElement) {
            this.dateComponent.initDate(utils.getUrlParam('date'));
            this.timeComponent.initValue(utils.getUrlParam('time'), this.dateComponent.getDate());
            this.fromComponent.initValue(utils.getUrlParam('from'), true);
            this.toComponent.initValue(utils.getUrlParam('to'), true);
            this.journeyModeComponent.initMode(utils.getUrlParam('mode'));
            this.criteriaComponent.initValue(utils.getUrlParam('criteria'));
            if (utils.getUrlParam('units')) {
              this.unitSystem = utils.getUrlParam('units');
              this.unitSystemComponent.setValue(this.unitSystem);
              this.unitSystemComponent.init();
            }
            google.maps.event.trigger(this.map, 'loaded');

          }
          // TODO Reinitialise the widget
        },

        close: function() {
          // TODO Free any resource and close.
        },

        //------------------------------------------------------------------------------------------------------------------------------
        /**
         * Returns a property value from the API Object. If the object returned by de the API Object was a function,
         * the final returned value would be the one resulted from the invocation to such a function,
         * otherwise the object will be returned as it was. Nevertheless, if the property was not defined or the value was 'undefined',
         * 'null' would be returned.
         *
         * @param apiObject The API Object.
         * @param {string} propertyName The name of the property from which to obtain the value.
         */
        _getAPIObjectValue: function(apiObject, propertyName) {
          var value = utils.getPropertyValue(apiObject, propertyName);
          if (value !== null) {
            if (utils.isFunction(value)) {
              return value();
            } else if (typeof value !== 'undefined') {
              return value;
            }
          }
          return null;
        },
        _onExchange: function() {
          var fromValue = this.fromComponent.getValue();
          var toValue = this.toComponent.getValue();
          this.fromComponent.setValue(toValue, false);
          this.toComponent.setValue(fromValue, false);
          this.fromComponent.validateValue(true);
          this.toComponent.validateValue(true);
        }



      });

      var module = {
        createWidget: function(apiObject) {
          return new MapWidget(apiObject);
        },
        getMap: function() {
          return mapInstance;
        },
        getNewJourney: function(widget, callback) {
          var from = widget.fromComponent.getValue().name;
          var to = widget.toComponent.getValue().name;
          var dateDeparture = widget.dateComponent.getDate();
          var timeDeparture = widget.timeComponent;
          var travelDate = new Date(dateDeparture.getFullYear(), dateDeparture.getMonth(), dateDeparture.getDate(),
            timeDeparture.getHours(), timeDeparture.getMinutes());
          var journeyMode = widget.journeyModeComponent.getValue();
          var criteria = widget.criteriaComponent.getValue();
          var optCriteria = widget.criteriaComponent.getOptions();
          var objCriteria = jQuery.grep(optCriteria, function(obj) {
            return obj.text === criteria;
          });
          var opt = {
            departureDirection: from,
            arrivalDirection: to,
            routingPreference: objCriteria[0].travelCriteria === '' ? false : objCriteria[0].travelCriteria,
            unitSystem: widget.unitSystem
          };
          var deferred = new jQuery.Deferred();
          if (journeyMode.toLowerCase() === 'depart after' && utils.isDate(travelDate) && from !== '' && to !==
            '') {
            this._calculateLocalTime(widget, travelDate, 'departure').done(function(time) {
              opt.departureTime = time;
              opt.arrivalTime = false;
              deferred.resolve();
            });
            deferred.promise().done(function() {
              widget.getJourney(from, to, opt, callback);
            });
          } else if (journeyMode.toLowerCase() === 'arrive before' && utils.isDate(travelDate) && from !== '' &&
            to !== '') {
            this._calculateLocalTime(widget, travelDate, 'arrival').done(function(time) {
              opt.arrivalTime = time;
              opt.departureTime = false;
              deferred.resolve();
            });
            deferred.promise().done(function() {
              widget.getJourney(from, to, opt, callback);
            });
          } else {
            if (window.innerWidth <= 540) {
              jQuery(widget.formControl).find('.form-components-container').closest('.mobile-mode').css(
                'padding', '0');
              jQuery(widget.formControl).find('.form-components-container').css('display', 'block');
              if (widget.journeysComponent) {
                widget.journeysComponent.getElement().find('.panel-heading').show();
              }
            }
          }
        },
        _calculateLocalTime: function(widget, time, depArr) {
          var origin = widget.fromComponent.getValue(),
            destination = widget.toComponent.getValue(),
            address, localTime, deferred = new jQuery.Deferred();
          time.value = time;
          address = depArr === 'departure' ? origin : destination;
          utils.getTimeOffsetByCoord(address.coordinates, time.getTime(), widget.apiObject).done(function(
            localOffset) {
            var offset = -(time.getTimezoneOffset() - localOffset);
            localTime = utils.getTimeInLocalGMT(time.getTime(), offset);
            deferred.resolve(new Date(localTime));
          });

          return deferred.promise();
        }


      };

      return module;

    });
})();

